import { format } from "date-fns";
import { es } from "date-fns/locale";
import styles from "./SuccessState.module.css";

/**
 * Componente SuccessState
 * Muestra el estado de éxito después de una solicitud exitosa
 *
 * @param {Object} props
 * @param {string} props.title - Título principal
 * @param {string} props.message - Mensaje descriptivo
 * @param {Object} props.reservation - Datos de la reserva
 * @param {function} props.onContinue - Función al hacer click en continuar
 * @param {function} props.onViewDetails - Función al hacer click en ver detalles
 * @param {boolean} props.darkMode - Modo oscuro
 */
const SuccessState = ({
  title = "¡Solicitud Enviada!",
  message = "Hemos recibido tu solicitud. Recibirás un correo de confirmación pronto con los detalles de tu reserva.",
  reservation,
  onContinue,
  onViewDetails,
  darkMode = false,
}) => {
  const formatDate = (date) => {
    if (!date) return "";
    return format(new Date(date), "d MMM yyyy", { locale: es });
  };

  return (
    <div
      className={`${styles["success-container"]} ${darkMode ? styles.dark : ""}`}
    >
      {/* Icono de éxito animado */}
      <div className={styles["success-icon-container"]}>
        <div className={styles["success-glow"]}></div>
        <div className={styles["success-icon-wrapper"]}>
          <span className={styles["success-icon"]}>✓</span>
        </div>
      </div>

      {/* Texto */}
      <h2 className={styles["success-title"]}>{title}</h2>
      <p className={styles["success-message"]}>{message}</p>

      {/* Resumen de la reserva */}
      {reservation && (
        <div className={styles["success-summary"]}>
          <div className={styles["summary-content"]}>
            <div
              className={styles["summary-thumbnail"]}
              style={{ backgroundImage: `url(${reservation.thumbnail})` }}
              role="img"
              aria-label={reservation.hotelName}
            />
            <div className={styles["summary-details"]}>
              <h3 className={styles["summary-title"]}>
                {reservation.hotelName}
              </h3>
              <div className={styles["summary-status"]}>
                <span className={styles["summary-status-icon"]}>✓</span>
                <span>Solicitud procesada</span>
              </div>
              {reservation.checkIn && reservation.checkOut && (
                <p className={styles["summary-dates"]}>
                  {formatDate(reservation.checkIn)} -{" "}
                  {formatDate(reservation.checkOut)} • {reservation.nights}{" "}
                  {reservation.nights === 1 ? "Noche" : "Noches"}
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Acciones */}
      <div className={styles["success-actions"]}>
        <button
          className={styles["success-button-primary"]}
          onClick={onContinue}
          type="button"
        >
          Continuar
          <span className={styles["success-button-arrow"]}>→</span>
        </button>

        {onViewDetails && (
          <button
            type="button"
            className={styles["success-link"]}
            onClick={(e) => {
              e.preventDefault();
              onViewDetails();
            }}
          >
            Ver detalles de la solicitud
          </button>
        )}
      </div>
    </div>
  );
};

export default SuccessState;
